import Index from './index.vue'
import Personalized from './personalizeDashboard.vue'
import BlankLayout from '../layout/blankLayout.vue'

const prefixPath = '/v-admin/hr-dashboard'

const route = [
  {
    name: 'hrDashboardNew',
    path: `${prefixPath}/index`,
    component: Index,
    meta: {
      titleI18nKey: 'admin.hrDashboard.title'
    }
  },
  {
    name: 'hrDashboardPersonalized',
    path: `${prefixPath}/personalized`,
    component: Personalized,
    meta: {
      titleI18nKey: 'admin.hrDashboard.personalTitle'
    }
  }
]

const hrDashboardRoute = {
  name: 'hrDashboardRoute_New',
  path: prefixPath,
  redirect: `${prefixPath}/index`,
  component: BlankLayout,
  meta: {
    isInclude: true,
    permission: ['PERM_HR_DASHBOARD', 'PREMIUM_HR_DASHBOARD'],
    titleI18nKey: 'admin.hrDashboard.title'
  },
  children: route
}

export default hrDashboardRoute
